import { useEffect, useSyncExternalStore } from "react";

let claims = 0;
const listeners = new Set<() => void>();

function emit() {
  for (const listener of listeners) listener();
}

function subscribe(listener: () => void): () => void {
  listeners.add(listener);
  return () => {
    listeners.delete(listener);
  };
}

function getSnapshot(): boolean {
  return claims > 0;
}

/**
 * Mount-scoped claim on the global OfflineChip. While at least one component
 * holds a claim, the floating chip in __root.tsx suppresses itself so the
 * claiming surface (currently the project header) can render its own inline
 * indicator without a duplicate floating pill.
 */
export function useClaimOfflineChip(): void {
  useEffect(() => {
    claims += 1;
    emit();
    return () => {
      claims -= 1;
      emit();
    };
  }, []);
}

export function useOfflineChipClaimed(): boolean {
  return useSyncExternalStore(subscribe, getSnapshot, () => false);
}
